import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ScorecardopportunityService {

  constructor(private http: HttpClient) { }

    public scorecardopportunitydashboard(filters: String): Observable<any> {
      return this.http.get<any[]>(`${environment.apiUrl}/TotalCount?${filters}`);
    } 

}
